// @ts-nocheck
/* eslint-disable */
export const crossIcon = {
    data: `<svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 8 8"><path fill="#172E63" d="M7.333 1.338 6.662.667 4 3.329 1.338.667l-.671.671L3.329 4 .667 6.662l.671.672L4 4.672l2.662 2.662.671-.672L4.671 4z"/></svg>`,
    name: 'cross' as const
};